module.exports = __webpack_public_path__ + "media/images/icons/sw-pt1-icon-9fb7d956821c4a3923738ca11fc89b06.svg";